import React, { useMemo, useState } from 'react'
import styles from './styles.module.scss'
import { truncateJsonDeep } from './shared'

interface JsonViewerProps {
    title: string
    data: any
    emptyMessage?: string
}

export const JsonViewer = ({ title, data, emptyMessage = 'No data' }: JsonViewerProps) => {
    const [showFull, setShowFull] = useState(false)
    const [copied, setCopied] = useState(false)

    const rendered = useMemo(() => {
        if (data == null) return null
        const value = showFull ? data : truncateJsonDeep(data)
        return JSON.stringify(value, null, 2)
    }, [data, showFull])

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(JSON.stringify(data, null, 2))
            setCopied(true)
            setTimeout(() => setCopied(false), 1500)
        } catch {
            /* clipboard unavailable */
        }
    }

    return (
        <div className={styles.jsonViewer}>
            <div className={styles.jsonViewerHeader}>
                <h5>{title}</h5>
                {data != null && (
                    <div className={styles.jsonViewerActions}>
                        <label>
                            <input type="checkbox" checked={showFull} onChange={(e) => setShowFull(e.target.checked)} />
                            Show full values
                        </label>
                        <button onClick={copy}>{copied ? 'Copied' : 'Copy JSON'}</button>
                    </div>
                )}
            </div>
            {rendered ? <pre>{rendered}</pre> : <p className={styles.jsonViewerEmpty}>{emptyMessage}</p>}
        </div>
    )
}
